import {
  Box,
  Typography,
  Container,
  Paper,
  List,
  ListItem,
} from "@mui/material";
import { motion } from "framer-motion";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const extraCurricular = [
  {
    title: "Governing Pannel Member",
    organization: "Brac University Chess Club",
    duration: "May 2023 - Present",
    description: [
      "Serving as General Secretary of the BRAC University Chess Club (BUCHC), leading strategic initiatives and organizational operations. I play a key role in both skill development and event management, regularly training club members from beginners to advanced players with focus on strategy, tactics, and tournament preparation.",
      "Successfully organized and executed multiple large-scale chess tournaments, each hosting over 200–300 participants from various institutions. These events required detailed planning, coordination, and real-time problem-solving, helping the club earn a reputation for professionalism and competitive excellence.",
      "Managing club operations, member engagement, and fostering a strong chess culture while building a thriving community. My leadership reflects dedication to excellence and continuous growth of the chess community at BRAC University.",
    ],
  },
  // Add more extra-curricular activities here
];

const ExtraCurricular = () => {
  return (
    <Box id="extracurricular" sx={{ py: 8, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Extra-Curricular Activities
          </Typography>
          {extraCurricular.map((activity, index) => (
            <Paper key={index} elevation={3} sx={{ p: 4, mb: 4 }}>
              <Box display="flex" alignItems="center" mb={2}>
                <EmojiEventsIcon color="primary" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h6">{activity.title}</Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {activity.organization} • {activity.duration}
                  </Typography>
                </Box>
              </Box>
              <List>
                {activity.description.map((item, i) => (
                  <ListItem
                    key={i}
                    sx={{
                      display: "list-item",
                      listStyleType: "disc",
                      pl: 0,
                      ml: 2,
                    }}
                  >
                    <Typography variant="body1">{item}</Typography>
                  </ListItem>
                ))}
              </List>
            </Paper>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default ExtraCurricular;
